<template>
  <div id="company">
    <div style="display:flex;justify-content: flex-end;">
      <el-button style=" background-color: #000;color: #fff;" @click="handleEdit(0, null)">添加商品分类</el-button>
    </div>
    <template>
      <el-row>
        <el-col :span="8">
          <el-table :data="parentlist" @row-click="handleCurrentChange" style="width: 100%" height="1000">
            <el-table-column label="一级分类图标" width>
              <template width="90" slot-scope="scope">
                <img style="width:104px;height:30px;border:none;" :src="scope.row.imgUrl" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="一级分类" width></el-table-column>
            <el-table-column label="操作选项">
              <template slot-scope="scope">
                <el-button
                  style="margin-right:5px"
                  size="mini"
                  @click="handleEditOne(1, scope.row)"
                >编辑</el-button>
                <el-popconfirm
                  icon="el-icon-delete"
                  icon-color="red"
                  title="确定删除吗？"
                  @confirm="handleDelete(1,scope.row)"
                >
                  <el-button size="mini" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="15">
          <el-table :data="childlist" style="width: 100%">
            <el-table-column label="二级分类图标" width>
              <template width="90" slot-scope="scope">
                <img style="width:60px;height:60px;border:none;" :src="scope.row.imgUrl" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="二级分类" width></el-table-column>
            <el-table-column label="操作选项">
              <template slot-scope="scope">
                <!-- <el-button size="mini" @click="handleEdit(2, scope.row)">编辑</el-button> -->
                <!-- <el-button size="mini" type="danger" @click="handleDelete(2, scope.row)">删除</el-button> -->
                <el-button
                  style="margin-right:5px"
                  size="mini"
                  @click="handleEditTwo(1, scope.row)"
                >编辑</el-button>
                <el-popconfirm
                  icon="el-icon-delete"
                  icon-color="red"
                  title="确定删除吗？"
                  @confirm="handleDelete(2,scope.row)"
                >
                  <el-button size="mini" type="danger" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <!-- 分类编辑分开做 -->
    <div>
      <el-dialog title="一级分类编辑" :visible.sync="editDialogVisible" width="30%">
        <span>
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="一级分类" prop="type" :labelWidth="formLabelWidth">
              <el-input v-model="form.type" clearable></el-input>
            </el-form-item>
            <!-- 一级分类图片 -->
            <el-form-item label="一级分类图片(523*150)" :label-width="formLabelWidth">
              <el-upload
                :data="qiniu"
                action="https://upload-z0.qiniup.com"
                :show-file-list="false"
                :multiple="false"
                :before-upload="(file) => { return handleBeforeUpload(file, 'typeone') }"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'typeone') }"
              >
                <img v-if="imgBackUrl" :src="imgBackUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div style="display:flex;justify-content:flex-end">
            <el-button @click="handleCancleOne()">取 消</el-button>
            <el-button type="primary" @click="handleAddOne()">确 定</el-button>
          </div>
        </span>
      </el-dialog>
    </div>
    <!-- 二级分类编辑分开做 -->
    <div>
      <el-dialog title="二级分类编辑" :visible.sync="editDialogVisible2" width="30%">
        <span>
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="一级分类" prop="parentId" :label-width="formLabelWidth">
              <el-select v-model="form.parentId" filterable placeholder="请选择">
                <el-option
                  v-for="item in parentlist"
                  :key="item.key"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级分类" prop="type" :labelWidth="formLabelWidth">
              <el-input v-model="form.type" clearable></el-input>
            </el-form-item>
            <!-- 二级分类图片 -->
            <el-form-item label="二级分类图片(120*120)" :label-width="formLabelWidth">
              <el-upload
                :data="qiniu"
                action="https://upload-z0.qiniup.com"
                :show-file-list="false"
                :multiple="false"
                :before-upload="(file) => { return handleBeforeUpload(file, 'type') }"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'type') }"
              >
                <img v-if="imgUrl" :src="imgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div style="display:flex;justify-content:flex-end">
            <el-button @click="handleCancleTwo()">取 消</el-button>
            <el-button type="primary" @click="handleAddTwo()">确 定</el-button>
          </div>
        </span>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="一级分类" name="first">
            <el-form :model="form" :rules="rules" ref="form">
              <el-form-item label="一级分类" prop="type" :labelWidth="formLabelWidth">
                <el-input v-model="form.type" clearable></el-input>
              </el-form-item>
              <!-- 一级分类图片 -->
              <el-form-item label="一级分类图片(523*150)" :label-width="formLabelWidth">
                <el-upload
                  class="avatar-uploader"
                  :data="qiniu"
                  action="https://upload-z0.qiniup.com"
                  :show-file-list="false"
                  :multiple="false"
                  :before-upload="(file) => { return handleBeforeUpload(file, 'typeone') }"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'typeone') }"
                >
                  <img v-if="imgBackUrl" :src="imgBackUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="二级分类" name="second">
            <el-form :model="form" :rules="rules" ref="form">
              <el-form-item label="一级分类" prop="parentId" :label-width="formLabelWidth">
                <el-select v-model="form.parentId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in parentlist"
                    :key="item.key"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级分类" prop="type" :labelWidth="formLabelWidth">
                <el-input v-model="form.type" clearable></el-input>
              </el-form-item>
              <!-- 二级分类图片 -->
              <el-form-item label="二级分类图片(120*120)" :label-width="formLabelWidth">
                <!-- 
              ##  token
              ##  必选参数上传地址
              ##  是否显示已上传文件列表
              ##  是否支持多选文件
              ##  上传之前
              ##  上传成功
                -->
                <el-upload
                  class="avatar-uploader"
                  :data="qiniu"
                  action="https://upload-z0.qiniup.com"
                  :show-file-list="false"
                  :multiple="false"
                  :before-upload="(file) => { return handleBeforeUpload(file, 'type') }"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'type') }"
                >
                  <img v-if="imgUrl" :src="imgUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleSave(activeName)">确 定</el-button>
        </span>
        <!-- <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave(activeName)">确 定</el-button>
        </div>-->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { goodsTypegetByParentId, goodsTypeadd, goodsTypedelete, qiniuupload, updateProductType } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      editDialogVisible: false,
      editDialogVisible2: false,
      // visible: false,
      // visible1: false,
      imgBackUrl: '',
      imgUrl: '',//解决图片回显问题
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      parentlist: [], //  父级分类
      childlist: [], //  子级分类
      centerDialogVisible: false,
      form: { //  新增初始化form
        id: '',
        parentId: '',
        type: '',
      },
      rules: {
        parentId: [{ required: true, message: '请选择一级分类', trigger: 'change' }],
        type: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      },
      activeName: 'first',
      formLabelWidth: '200px',
      sts: 0, //  0 添加, 1 编辑
      title: '', //  添加窗口标题
      currentid: ''
    }
  },
  methods: {
    handleAddTwo () {
      let para = new URLSearchParams()
      para.append('id', this.form.id)
      para.append('parentId', this.form.parentId)
      para.append('name', this.form.type)
      para.append('imgUrl', this.imgUrl)
      updateProductType(para).then(data => {
        if (data.code === 10000) {
          this.editDialogVisible2 = false
          this.form.id = ''
          this.form.type = ''
          this.imgUrl = ''
          this.form.parentId = ''
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getgoodsTypegetByParentId()
          this.getgoodsTypegetByParentId(1)

        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    handleAddOne () {
      let para = new URLSearchParams()
      para.append('id', this.form.id)
      para.append('name', this.form.type)
      para.append('imgUrl', this.imgBackUrl)
      updateProductType(para).then(data => {
        if (data.code === 10000) {
          this.editDialogVisible = false
          this.form.id = ''
          this.form.type = ''
          this.imgBackUrl = ''
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getgoodsTypegetByParentId()
          this.getgoodsTypegetByParentId(1)
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    handleCancleTwo () {
      this.editDialogVisible2 = false
      this.form.type = ''
      this.imgUrl = ''
      this.form.id = ''
      this.form.parentId = ''
    },
    handleCancleOne () {
      this.form.id = ''
      this.form.type = ''
      this.imgBackUrl = ''
      this.editDialogVisible = false
    },
    handleEditTwo (ind, row) {
      console.log(ind, row);
      this.editDialogVisible2 = true
      this.form.type = row.name
      this.imgUrl = row.imgUrl
      this.form.id = row.id
      this.form.parentId = row.parentId
    },
    handleEditOne (ind, row) {
      console.log(ind, row);
      this.editDialogVisible = true
      this.form.type = row.name
      this.imgBackUrl = row.imgUrl
      this.form.id = row.id
    },
    // 气泡框
    handleConfirm (i) {
      console.log(111);
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后
      if (obj === 'typeone') {
        this.imgBackUrl = this.uploadUrl + '/' + response.key
      } else {
        this.imgUrl = this.uploadUrl + '/' + response.key
      }
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },

    handleCurrentChange (row) {
      this.getgoodsTypegetByParentId(row.id)
    },
    handleCancel () {
      this.centerDialogVisible = false
      this.imgUrl = ''
      this.imgBackUrl = ''

    },
    handleSave (s) { //  添加分类
      let para = new URLSearchParams()
      if (s === 'first') {
        para.append('name', this.form.type)
        para.append('imgUrl', this.imgBackUrl)
      } else {
        para.append('parentId', this.form.parentId)
        para.append('name', this.form.type)
        para.append('imgUrl', this.imgUrl)
      }
      if (this.sts === 0) {
        goodsTypeadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsTypegetByParentId()
            this.getgoodsTypegetByParentId(1)
            this.centerDialogVisible = false
            this.imgUrl = ''
            this.imgBackUrl = ''
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        para.append('id', this.currentid)
        goodsTypeupdateById(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsTypegetByParentId(1)
            this.getgoodsTypegetByParentId(1, this.form.parentId)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }

    },
    handleClick () {
      this.form = {}
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      if (ind === 1) {
        this.currentid = row.id
        this.title = '编辑商品分类'
        this.form.type = row.name
        this.sts = 1
        this.activeName = 'first'
      } else if (ind === 0) {
        this.title = '新增商品分类'
        this.form = {}
        this.sts = 0
      } else {
        this.currentid = row.id
        this.activeName = 'second'
        this.form.parentId = row.parent
        this.form.type = row.name
        this.sts = 2
      }
    },
    handleDelete (ind, row) { //  删除
      let para = new URLSearchParams()
      para.append('id', row.id)
      goodsTypedelete(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //删除之后的操作
          this.getgoodsTypegetByParentId()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    getgoodsTypegetByParentId (p) { //  查询全部
      let para = new URLSearchParams()
      if (p) {
        para.append('parentId', p)
        para.append('pageIndex', 1)
        para.append('pageSize', 300)
        goodsTypegetByParentId(para).then(data => {
          // console.log(data);
          this.childlist = data.data.rows
        })
      } else {
        para.append('pageIndex', 1)
        para.append('pageSize', 300)
        goodsTypegetByParentId(para).then(data => {
          if (data.code === 10000) {
            this.parentlist = data.data.rows
            this.getgoodsTypegetByParentId(this.parentlist[0].id)
          } else {
            // console.log(data)
          }
        })
      }
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.token
        this.uploadUrl = res.data.bucketUrl
      })
    }
  },
  mounted () {
    this.getgoodsTypegetByParentId()
    this.getToken()
  }
}
</script>
<style lang="stylus">
#company {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-popover {
    line-height: 1.8 !important;
  }
}
</style>
